module.exports = __webpack_public_path__ + "static/fonts/Nunito-Bold.1e9ac7c.woff";